import * as actions from './i18n.actions'

const initialState = {
  locale: 'en', // Default to 'en' for react-intl v5 compatibility
  messages: {
    loading: 'Loading... {percent}%',
  },
}

const actionsMap = {
  [actions.LOAD_MESSAGES_FINISH]: (state, action) => {
    const { locale, messages } = action.data
    return { locale, messages }
  },
  [actions.LOAD_TUTORIAL_MESSAGES_FINISH]: (state, action) => {
    const { locale, messages } = action.data
    return { locale, messages }
  },
}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
